module.exports = __webpack_public_path__ + "img/forum-events-180.38c82596.png";